import _objectSpread from "@babel/runtime/helpers/objectSpread";
import getChildEventSubscriber from './getChildEventSubscriber';
import getChildRouter from './getChildRouter';
import getNavigationActionCreators from './routers/getNavigationActionCreators';
import getChildrenNavigationCache from './getChildrenNavigationCache';

var createParamGetter = function createParamGetter(route) {
  return function (paramName, defaultValue) {
    var params = route.params;

    if (params && paramName in params) {
      return params[paramName];
    }

    return defaultValue;
  };
};

function _getChildNavigation(navigation, childKey, getCurrentParentNavigation) {
  var children = getChildrenNavigationCache(navigation);
  var childRoute = navigation.state.routes.find(function (r) {
    return r.key === childKey;
  });

  if (!childRoute) {
    return null;
  }

  if (children[childKey] && children[childKey].state === childRoute) {
    return children[childKey];
  }

  var childRouter = getChildRouter(navigation.router, childRoute.routeName);
  var focusedGrandChildRoute = childRoute.routes && typeof childRoute.index === 'number' ? childRoute.routes[childRoute.index] : null;

  var actionCreators = _objectSpread({}, navigation.actions, navigation.router.getActionCreators(childRoute, navigation.state.key), childRouter ? childRouter.getActionCreators(focusedGrandChildRoute, childRoute.key) : {}, getNavigationActionCreators(childRoute));

  var actionHelpers = {};
  Object.keys(actionCreators).forEach(function (actionName) {
    actionHelpers[actionName] = function () {
      var actionCreator = actionCreators[actionName];
      var action = actionCreator.apply(void 0, arguments);
      return navigation.dispatch(action);
    };
  });
  var _isFirstRouteInParent = true;
  var parentNavigation = getCurrentParentNavigation();

  if (parentNavigation) {
    _isFirstRouteInParent = parentNavigation.state.routes.indexOf(childRoute) === 0;
  }

  if (children[childKey] && children[childKey].isFirstRouteInParent() === _isFirstRouteInParent) {
    children[childKey] = _objectSpread({}, children[childKey], actionHelpers, {
      state: childRoute,
      router: childRouter,
      actions: actionCreators,
      getParam: createParamGetter(childRoute)
    });
    return children[childKey];
  } else {
    var childSubscriber = getChildEventSubscriber(navigation.addListener, childKey);
    children[childKey] = _objectSpread({}, actionHelpers, {
      state: childRoute,
      router: childRouter,
      actions: actionCreators,
      getParam: createParamGetter(childRoute),
      getChildNavigation: function getChildNavigation(grandChildKey) {
        return _getChildNavigation(children[childKey], grandChildKey, function () {
          var nav = getCurrentParentNavigation();
          return nav && nav.getChildNavigation(childKey);
        });
      },
      isFocused: function isFocused() {
        var currentNavigation = getCurrentParentNavigation();

        if (!currentNavigation) {
          return false;
        }

        var _currentNavigation$st = currentNavigation.state,
            routes = _currentNavigation$st.routes,
            index = _currentNavigation$st.index;

        if (!currentNavigation.isFocused()) {
          return false;
        }

        if (routes[index].key === childKey) {
          return true;
        }

        return false;
      },
      isFirstRouteInParent: function isFirstRouteInParent() {
        return _isFirstRouteInParent;
      },
      dispatch: navigation.dispatch,
      getScreenProps: navigation.getScreenProps,
      dangerouslyGetParent: getCurrentParentNavigation,
      addListener: childSubscriber.addListener,
      emit: childSubscriber.emit
    });
    return children[childKey];
  }
}

export default _getChildNavigation;